import { useContext, useEffect } from 'react';
import { DiseaseContext } from '../../Context/Disease';
import { fetchAfricaSummaryAction } from '../../Context/Disease/action';
import numeral from 'numeral';
import Loader from '../../Components/Lottie';
import loader from '../../Assets/json/spinner.json';

const AfricaDataCard = () => {
  const {
    diseaseState: { africanSummary, fetchingAfricanSummary },
    dispatch,
  } = useContext(DiseaseContext);
  
  useEffect(() => {
    dispatch(fetchAfricaSummaryAction);
  }, [dispatch]);

  return (
    <div className="py-5 slg:py-12 bg-moon px-6 md:px-8 w-full md:bg-white rounded md:shadow-sub4 slg:w-auto">
      <h6 className="leading-48 text-xl text-chestNut font-bold font-tiempos">Africa</h6>
      <div className="flex items-center justify-between mt-4 slg:flex-col slg:items-start">
        <div className="slg:mb-6 ">
          <h6 className="slg:text-2rem md:text-28px md:leading-34 font-bold text-boudoir leading-5">
            {fetchingAfricanSummary && (
              <span className="w-10 h-10 block">
                <Loader loader={loader} />
              </span>
            )}
            {!fetchingAfricanSummary && numeral(africanSummary?.cases).format()}
          </h6>
          <span className="text-xs leading-6 slg:text-sm  text-metal">
            Total Cases
          </span>
        </div>
        <div className="slg:mb-6">
          <h6 className="slg:text-2rem md:text-28px md:leading-34 font-bold text-boudoir leading-5">
            {fetchingAfricanSummary && (
              <span className="w-10 h-10 block">
                <Loader loader={loader} />
              </span>
            )}
            {!fetchingAfricanSummary &&
              numeral(africanSummary?.active).format()}
          </h6>
          <span className="text-xs leading-6 slg:text-sm  text-metal">
            Active Cases
          </span>
        </div>
        <div className="slg:mb-6">
          <h6 className="slg:text-2rem md:text-28px md:leading-34 font-bold text-boudoir leading-5">
            {fetchingAfricanSummary && (
              <span className="w-10 h-10 block">
                <Loader loader={loader} />
              </span>
            )}
            {!fetchingAfricanSummary &&
              numeral(africanSummary?.deaths).format()}
          </h6>
          <span className="text-xs leading-6 slg:text-sm  text-metal">
            Deaths
          </span>
        </div>
      </div>
    </div>
  );
};

export default AfricaDataCard;
